import IPbiPaginatedReport from "../models/IPbiPaginatedReport";
import { fetchSecureData } from "../utils";

export const getRolePaginatedReports = async (
    accessToken: string,
    roleId: number
) => {
    try {
        const data = await fetchSecureData(
            "GET",
            `/api/PbiPaginatedReport/GetPbiPaginatedReportsForRoleId?roleId=${roleId}`,
            accessToken
        );
        const rolePaginatedReports = ((await data.json()) as any)
            .value as IPbiPaginatedReport[];
        if (rolePaginatedReports !== undefined) {
            return rolePaginatedReports;
        } else {
            return [] as IPbiPaginatedReport[];
        }
    } catch (err) {
        // tslint:disable-next-line:no-console
        console.log(
            `Fetch error for /api/PbiPaginatedReport/GetPbiPaginatedReportsForRoleId?roleId=${roleId}`,
            err
        );
    }
    return [] as IPbiPaginatedReport[];
};

export default getRolePaginatedReports;
